import { AccessControlSource, ExecutionStatus } from "../model/types";

export const statusMapping: Record<ExecutionStatus, keyof typeof EXECUTION_STATUS_CATEGORY> = {
  completed: "success",
  done: "success",
  error: "error",
  failed: "error",
  pending: "pending",
  processing: "processing",
  queued: "pending",
  running: "processing",
  waiting: "pending",
};

export const EXECUTION_STATUS_CATEGORY = {
  error: {
    isTerminal: true,
  },
  pending: {
    isTerminal: false,
  },
  processing: {
    isTerminal: false,
  },
  success: {
    isTerminal: true,
  },
};

export const ANIMATION_DURATION = 1000;

export const IS_ALLOWED_BY: Record<string, AccessControlSource> = {
  BACKEND: "backend",
  FRONTEND: "frontend",
};
